
import { NavimowPagination } from './navimow-pagination.js?v=3';

class NavmowProductList {
  constructor(config) {
    this.list = config.list;
    this.mobileList = config.mobileList;
    this.productGrid = config.productGrid;
    this.paginationContainer = config.paginationContainer;
    this.productCardTemplate = config.productCardTemplate;
    this.productCount = config.productCount;
    this.groupTemplate = config.groupTemplate;
    this.optionTemplate = config.optionTemplate;
    this.sectionId = config.sectionId;
    this.collectionIds = config.collectionIds;
    this.marketHandle = config.marketHandle;
    this.saveType  = config.saveType  || 'percent';
    this.saveLabel = config.saveLabel || 'Save %s';
    this.itemsFoundLabel = config.itemsFoundLabel;

    // 用事件委托处理动态渲染的 sub-popup 按钮，避免 connectedCallback 时卡片尚未存在
    this.productGrid.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-product-sub-popup-btn]');
      if (!btn) return;
      const modalId = btn.getAttribute('aria-controls');
      const modal = modalId && document.getElementById(modalId);
      if (!modal) return;

      const tag = btn.dataset.subscribeTag;
      if (tag) {
        const form = modal.querySelector('form[id^="email-subscribe-"]');
        if (form) {
          const preTag = (form.dataset.preSubTag || '').trim();
          form.dataset.activeTag = preTag ? `${preTag}${tag}` : tag;
        }
      }

      if (modal.show) modal.show();
    });

    // state
    this.selectedItems = [];
    this.sortKey = '';
    this.reverse = false;
    this.pagination = null; // 分页组件实例
    this.productData = null; // 集合数据
    this.currentPageData = null; // 当前页数据

    this.pageSize = window.innerWidth > 768 ? parseInt(config.pageSize, 10) : parseInt(config.pageSizeMb, 10);
    this.currentPage = null; // 当前页码
    this.totalPages = 1; // 总页数

    this.readStateFromUrl();
    this.init();
  }

  // 请求产品集合数据（过滤条件 + 产品列表）
  async fetchFilters(init = false) {
    const res = await window.NW.request(`${window.baseUrl}/newOfficialWebsite/product/collection/config`, {
      method: 'POST',
      headers: { 'X-Site-Code': window.site },
      body: {
        productCollectionId: this.collectionIds.split('\n').map(id => id.trim()).filter(Boolean),
        country: this.marketHandle,
        itemIds: this.selectedItems,
        sortKey: this.sortKey,
        reverse: this.reverse,
      },
    });

    if (Number(res?.code) !== 200) throw new Error(res?.message || 'Failed to fetch filters');
    this.productData = res.data;
    this.totalPages = Math.ceil(res.data.products.length / this.pageSize);
    this.initPage(init);
    this.pageProducts(res.data);
    return res.data;
  }

  // 根据页码和每页数量过滤出当前页展示的产品数据
  pageProducts() {
    if (!this.currentPage) return;
    const startIdx = (this.currentPage - 1) * this.pageSize;
    const endIdx = startIdx + this.pageSize;
    const pagedProducts = this.productData.products.slice(startIdx, endIdx);
    this.currentPageData = {
      products: pagedProducts,
      productCollections: this.productData.productCollections,
    };
  }

  initPage(init = false) {
    const url = new URL(window.location.href);
    const page = parseInt(url.searchParams.get('page'), 10);
    if(page > this.totalPages || init) {
      url.searchParams.set('page', 1);
      window.history.replaceState({}, '', url);
    }
    if(page && page > 0 && page <= this.totalPages && !init) {
      this.currentPage = page;
    } else {
      this.currentPage = 1;
    }
  }

  // 渲染右侧产品网格，打平所有 collection ->  products
  renderProducts() {
    if (!this.currentPageData) return;
    this.productGrid.innerHTML = '';
    const products = this.currentPageData.products;
    this.productCount.forEach((el) => {
      el.textContent = this.itemsFoundLabel.replace('__COUNT__', products.length);
    });

    products.forEach(product => {
      const card = this.productCardTemplate.content.cloneNode(true);
      const link = card.querySelector('[data-product-href]');
      const imageWrapperEl = card.querySelector('[data-product-image-wrapper]');
      const imgEl = imageWrapperEl.querySelector('[data-product-image-main]');
      const overlayEl = card.querySelector('[data-overlay-image]');
      const priceEl = card.querySelector('[data-product-price]');
      const originalPriceEl = card.querySelector('[data-product-original-price]');
      const badgeEl = card.querySelector('[data-product-badge]');
      const badgeTextEl = card.querySelector('[data-product-badge-text]');
      const soldOutEl = card.querySelector('[data-product-sold-out]');
      const subBtn = card.querySelector('[data-product-sub-popup-btn]');

      const soldOut = product.stock <= 0;
      const onSale = product.originalPrice && product.originalPrice !== product.price;

      link.href = `/products/${product.handle}`;
      card.querySelector('[data-product-title]').textContent = product.title;

      if (product.image?.[0]) {
        imgEl.src = product.image[0];
      } else {
        imageWrapperEl.classList.add('tw-bg-[#e5e7eb]');
        imgEl.remove();
      }

      if (product.metaField?.product_overlay_image) {
        overlayEl.src = product.metaField.product_overlay_image;
      } else {
        overlayEl.remove();
      }

      priceEl.textContent = product.price;
      if (onSale) {
        originalPriceEl.textContent = product.originalPrice;
      } else {
        priceEl.classList.remove('tw-text-brand');
        originalPriceEl.remove();
      }

      let badgeText = product.metaField?.save_tag_text;
      if (!badgeText && !soldOut && product.savePrice) {
        // todo: this.saveType === 'label' 目前不会有这个情况，暂未国际化
        if (this.saveType === 'label')       badgeText = 'Sale';
        else if (this.saveType === 'dollar') badgeText = this.saveLabel.replace('%s', product.savePrice);
        else                                 badgeText = this.saveLabel.replace('%s', product.savePricePercent);
      }
      if (badgeText) {
        badgeTextEl.textContent = badgeText;
        badgeEl.classList.remove('tw-hidden');
      }

      if (soldOut) {
        subBtn.classList.remove('tw-hidden');
        subBtn.dataset.subscribeTag = product.title;
        soldOutEl.classList.remove('tw-hidden');
        link.classList.add('tw-opacity-50');
        priceEl.classList.add('tw-opacity-50');
        if (onSale) originalPriceEl.classList.add('tw-opacity-50');
      }

      this.productGrid.appendChild(card);
    });
  }

  // 渲染左侧过滤器（桌面端 + 移动端同步渲染）
  renderFilters(data) {
    [this.list, this.mobileList].forEach((container, ci) => {
      if (!container) return;

      // 刷新前记录每个 details 的展开状态，避免重建后全部重置为 open
      const openStates = [...container.querySelectorAll('details')].map(d => d.open);

      // 在 DocumentFragment 中组装好全部内容（含 open 状态），再一次性替换，避免闪烁
      const fragment = document.createDocumentFragment();

      data.productCollections.forEach((collection, i) => {
        const group = this.groupTemplate.content.cloneNode(true);
        group.querySelector('[data-filter-name]').textContent = collection.displayCopy;

        // 插入 DOM 前设置 open，避免先清空再写入导致的闪烁
        if (i < openStates.length) {
          group.querySelector('details').open = openStates[i];
        }

        const optionsEl = group.querySelector('[data-options]');
        collection.items.forEach((opt, j) => {
          const option = this.optionTemplate.content.cloneNode(true);
          const id = `filter-${this.sectionId}-${ci}-${i}-${j}`;
          const input = option.querySelector('input');
          input.id = id;
          input.dataset.optionId = opt.itemId;
          option.querySelector('label').setAttribute('for', id);
          option.querySelector('[data-option-label]').textContent = opt.name;
          if (opt.products <= 0) option.querySelector('label').classList.add('tw-option-disabled');
          optionsEl.appendChild(option);
        });

        fragment.appendChild(group);
      });

      container.replaceChildren(fragment);
    });

    this.bindCheckboxes();
    this.restoreCheckboxState();
  }

  // 恢复 checkbox 选中状态（renderFilters 重建 DOM 后同步）
  restoreCheckboxState() {
    this.list?.querySelectorAll('input[type="checkbox"]').forEach(cb => {
      cb.checked = this.selectedItems.includes(cb.dataset.optionId);
    });
    this.mobileList?.querySelectorAll('input[type="checkbox"]').forEach(cb => {
      cb.checked = this.selectedItems.includes(cb.dataset.optionId);
    });
  }

  // 桌面端 checkbox 即时触发查询；移动端只更新 pendingItems，等 Apply
  bindCheckboxes() {
    this.list?.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        const id = checkbox.dataset.optionId;
        this.selectedItems = checkbox.checked
          ? [...this.selectedItems, id]
          : this.selectedItems.filter(v => v !== id);
        this.writeStateToUrl();
        this.refresh(true);
      });
    });

    this.mobileList?.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        const id = checkbox.dataset.optionId;
        this.selectedItems = checkbox.checked
          ? [...this.selectedItems, id]
          : this.selectedItems.filter(v => v !== id);
        this.writeStateToUrl();
        this.refresh(true);
      });
    });
  }

  setLoading(loading) {
    const els = [this.productGrid, this.list, this.mobileList].filter(Boolean);
    els.forEach(el => el.classList.toggle('tw-opacity-50', loading));
    els.forEach(el => el.classList.toggle('tw-pointer-events-none', loading));
  }

  // 更新排序并重新查询
  setSort(sortKey, reverse) {
    this.sortKey = sortKey;
    this.reverse = reverse;
    this.writeStateToUrl();
    this.refresh(true);
  }

  // 重新拉取数据并刷新过滤器 + 产品网格
  async refresh(init = false) {
    this.setLoading(true);
    try {
      const data = await this.fetchFilters(init);
      this.renderFilters(data);
      this.renderProducts(data);
      this.renderPagination(data);
    } finally {
      this.setLoading(false);
    }

    const top = this.productGrid.getBoundingClientRect().top + window.scrollY - 150;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  async init() {
    this.setLoading(true);
    try {
      const data = await this.fetchFilters();
      this.renderFilters(data);
      this.renderProducts(data);
      this.renderPagination(data);
      this.updateClearVisibility();
    } finally {
      this.setLoading(false);
    }
  }

  readStateFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const f = params.get('f');
    this.selectedItems = f ? f.split(',').filter(Boolean) : [];
    this.sortKey = params.get('sort') || '';
    this.reverse = params.get('rev') === '1';
  }

  writeStateToUrl() {
    const params = new URLSearchParams(window.location.search);
    if (this.selectedItems.length) {
      params.set('f', this.selectedItems.join(','));
    } else {
      params.delete('f');
    }
    if (this.sortKey) {
      params.set('sort', this.sortKey);
      params.set('rev', this.reverse ? '1' : '0');
    } else {
      params.delete('sort');
      params.delete('rev');
    }
    const qs = params.toString();
    history.replaceState(null, '', qs ? `?${qs}` : window.location.pathname);
    this.updateClearVisibility();
  }

  updateClearVisibility() {
    const active = this.selectedItems.length > 0 || this.sortKey !== '';
    this.productGrid.closest('[data-navmow-product-list]')
      ?.querySelectorAll('[data-filter-clear]')
      .forEach(btn => btn.classList.toggle('tw-hidden', !active));
  }

  renderPagination(data) {
    if (!this.paginationContainer) return;

    if (!this.pagination) {
      this.pagination = new NavimowPagination({
        container: this.paginationContainer,
        productGrid: this.productGrid,
        totalPages: this.totalPages,
        currentPage: this.currentPage,
        onChange: (page) => {
          this.currentPage = page;
          this.pageProducts();
          this.renderProducts();
        },
      });
      return;
    }

    this.pagination.update({ totalPages: this.totalPages, currentPage: this.currentPage });
  }

  syncSortUI(sortOptions, label) {
    if (!sortOptions.length || !label) return;
    sortOptions.forEach(o => o.classList.remove('tw-opacity-50', 'tw-pointer-events-none'));
    const active = sortOptions.find(
      o => o.dataset.sortKey === this.sortKey && (o.dataset.sortReverse === 'true') === this.reverse
    ) || sortOptions[0];
    label.textContent = active.textContent.trim();
    active.classList.add('tw-opacity-50', 'tw-pointer-events-none');
  }
}

document.querySelectorAll('[data-navmow-product-list]').forEach(el => {
  // Sort dropdown
  const trigger = el.querySelector('[data-sort-trigger]');
  const dropdown = el.querySelector('[data-sort-dropdown]');
  const label = el.querySelector('[data-sort-label]');
  const icon = trigger?.querySelector('[data-icon]');
  const pageSize = el.dataset.currentPageSize;
  const pageSizeMb = el.dataset.currentPageSizeMb;
  trigger?.addEventListener('click', (e) => {
    e.stopPropagation();
    const isOpen = !dropdown.classList.contains('tw-hidden');
    dropdown.classList.toggle('tw-hidden', isOpen);
    icon?.classList.toggle('-tw-rotate-180', !isOpen);
  });

  document.addEventListener('click', () => {
    dropdown?.classList.add('tw-hidden');
    icon?.classList.remove('-tw-rotate-180');
  });

  const instance = new NavmowProductList({
    sectionId: el.dataset.navmowProductList,
    collectionIds: el.dataset.collectionIds,
    list: document.getElementById(el.dataset.filterListId),
    mobileList: document.getElementById(el.dataset.filterListMobileId),
    productGrid: document.getElementById(el.dataset.productGridId),
    productCardTemplate: document.getElementById(el.dataset.productCardTemplateId),
    productCount: el.querySelectorAll('[data-product-count]'),
    groupTemplate: document.getElementById(el.dataset.groupTemplateId),
    optionTemplate: document.getElementById(el.dataset.optionTemplateId),
    marketHandle: el.dataset.currentMarketHandle,
    saveType: el.dataset.saveType,
    saveLabel: el.dataset.saveLabel,
    itemsFoundLabel: el.dataset.itemsFoundLabel,
    paginationContainer: el.querySelector('.navimow-pagination-container'),
    pageSize: pageSize,
    pageSizeMb: pageSizeMb,
  });
  const sortOptions = dropdown ? [...dropdown.querySelectorAll('[data-sort-option]')] : [];

  instance.syncSortUI(sortOptions, label);

  const handleClearAll = () => {
    const openDefault = el.dataset.openFiltersDefault === 'true';
    el.querySelectorAll('details[is="accordion-details"]').forEach((d) => {
      d.open = openDefault;
    });
    instance.selectedItems = [];
    instance.sortKey = '';
    instance.reverse = false;
    instance.syncSortUI(sortOptions, label);
    instance.writeStateToUrl();
    instance.refresh();
  };

  el.querySelectorAll('[data-filter-clear]').forEach(btn => btn.addEventListener('click', handleClearAll));

  sortOptions.forEach(option => {
    option.addEventListener('click', () => {
      label.textContent = option.textContent;
      dropdown.classList.add('tw-hidden');
      icon?.classList.remove('-tw-rotate-180');
      sortOptions.forEach(o => o.classList.remove('tw-opacity-50', 'tw-pointer-events-none'));
      option.classList.add('tw-opacity-50', 'tw-pointer-events-none');
      instance.setSort(option.dataset.sortKey, option.dataset.sortReverse === 'true');
    });
  });
});
